import React, { Component } from 'react';

import Immutable, {Range} from 'immutable';
import { firebaseRoot } from '../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route } from 'react-router';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import LinkTR from '../../components/LinkTR';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

const Book = React.createClass({
    mixins: [ReactFireMixin],

    rebind(props) {
        this.bindAsObject(firebaseRoot.child('admin/base/books').child(props.params.bookId), 'book');
        this.bindAsArray(firebaseRoot.child('admin/base/chapters').child(props.params.bookId), 'chapters');
        this.bindAsDataSnapshot(firebaseRoot.child('admin/stats/chapters').child(props.params.bookId), 'chapterStats');
        if (props.params.chapterId) {
            this.bindAsObject(firebaseRoot.child('admin/base/chapters')
                .child(props.params.bookId).child(props.params.chapterId), 'chapter');
            this.bindAsDataSnapshot(firebaseRoot.child('admin/stats/subchapters')
                .child(props.params.bookId).child(props.params.chapterId), 'subchapterStats');
            this.bindAsArray(firebaseRoot.child('admin/base/subchapters')
                .child(props.params.bookId).child(props.params.chapterId), 'subchapters');
        }
        if (props.params.subchapterId) {
            this.bindAsObject(
                firebaseRoot.child('admin/base/subchapters')
                    .child(props.params.bookId)
                    .child(props.params.chapterId)
                    .child(props.params.subchapterId),
                'subchapter');
        }
    },

    componentWillMount() {
        this.rebind(this.props);
    },

    componentWillReceiveProps(nextProps) {
        this.rebind(nextProps);
    },

    render() {
        if (!this.state || !this.state.book) {
            return <div>Loading...</div>;
        }
        const {book, chapter, subchapter} = this.state;

        return (
            <div className="admin-content-singel">
                <ol className="breadcrumb">
                    <li><TouchLink to={`/admin/book/${book['.key']}`}>{book.title}</TouchLink></li>
                    {chapter &&
                    <li><TouchLink to={`/admin/book/${book['.key']}/${chapter['.key']}`}>{chapter.name}</TouchLink></li>
                    }
                    {subchapter &&
                    <li className="active"><TouchLink to={`/admin/book/${book['.key']}/${chapter['.key']}/${subchapter['.key']}`}>{subchapter.name}</TouchLink></li>
                    }
                </ol>
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Name</th>
                        <th>Exercises</th>
                        <th>Started</th>
                        <th>Completed</th>
                        <th>Approved</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.chapters.map(chapter => {
                        let subchapters = null;
                        if (this.props.params.chapterId == chapter['.key']) {
                            subchapters = !this.state.subchapters ?
                                <div>Loading...</div> : this.state.subchapters.map(subchapter => {
                                const stats = this.state.subchapterStats.child(subchapter['.key']).val() || {};
                                return <LinkTR
                                    to={`/admin/book/${book['.key']}/${chapter['.key']}/${subchapter['.key']}`}>
                                    <td style={{paddingLeft: 40}}>{subchapter['.key']}</td>
                                    <td style={{paddingLeft: 40}}>{subchapter.name}</td>
                                    <td>{stats.total}</td>
                                    <td>{stats.started}</td>
                                    <td>{stats.completed}</td>
                                    <td>{stats.approved}</td>
                                </LinkTR>;
                            });
                        }
                        const stats = this.state.chapterStats.child(chapter['.key']).val() || {};
                        return [
                            <LinkTR to={`/admin/book/${book['.key']}/${chapter['.key']}`}>
                                <td>{chapter['.key']}</td>
                                <td>{chapter.name}</td>
                                <td>{stats.total}</td>
                                <td>{stats.started}</td>
                                <td>{stats.completed}</td>
                                <td>{stats.approved}</td>
                            </LinkTR>,
                            subchapters
                        ]
                    })}
                    </tbody>
                </table>
            </div>
        );
    }
});

export default Book;



/** WEBPACK FOOTER **
 ** ./src/admin/screens/Book.js
 **/